import * as types from '../../../constants/actionTypes';
import MODES from '../../../components/form/onSubmitModes';
import i18n from '../../../../shared/locales/no.json';

const initialState = {
    mode: MODES.VIEW,
    errorMsg: '',
    videos: [],
};

export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
        /* Add */
        case types.ADD_VIDEO:
            return {
                ...state,
                mode: MODES.SAVING,
            };
        case types.ADD_VIDEO_SUCCESS:
            return {
                ...state,
                mode: MODES.VIEW,
                errorMsg: '',
                videos: [...state.videos, action.result],
            };
        case types.ADD_VIDEO_FAIL:
            return {
                ...state,
                mode: MODES.VIEW,
                errorMsg: i18n.video.error.save,
            };

        /* Delete*/
        case types.DELETE_VIDEO:
            return {
                ...state,
                mode: MODES.SAVING,
            };
        case types.DELETE_VIDEO_SUCCESS:
            return {
                ...state,
                mode: MODES.VIEW,
                errorMsg: '',
                videos: state.videos.filter(
                    (item) => item.id !== action.videoId
                ),
            };
        case types.DELETE_VIDEO_FAIL:
            return {
                ...state,
                errorMsg: '',
                mode: MODES.VIEW,
            };

        /* Update */
        case types.UPDATE_VIDEO:
            return {
                ...state,
                mode: MODES.SAVING,
            };
        case types.UPDATE_VIDEO_SUCCESS: {
            return {
                ...state,
                mode: MODES.VIEW,
                errorMsg: '',
                videos: state.videos.map((video) =>
                    video.id === action.videoId
                        ? {
                              ...video,
                              ...action.result,
                          }
                        : video
                ),
            };
        }
        case types.UPDATE_VIDEO_FAIL:
            return {
                ...state,
                mode: MODES.VIEW,
                errorMsg: '',
            };

        /* All other type */
        default:
            return state;
    }
}
